import React, { useEffect, useRef, useState } from 'react';

import './Pedidos.css';
import { PedidosServices } from '../../services/PedidosService';
import { Button, Box, FormControl, InputLabel, MenuItem, Select, IconButton } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import SearchOffIcon from '@mui/icons-material/SearchOff';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import { Paper, Typography, Divider } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import CustomOrderTableComponent from '../../components/customTableOrder/CustomTabelaOrder';
import Loading from '../../components/loading/Loading';
import { UserInfo } from '../../dto/UserInfo';
import { Pedido as PedidoDto } from '../../dto/Pedidos';
import { ToastContainer } from 'react-toastify';
import { mostraMensagemErro } from '../../helpers/Notificacoes';
import { formataFiltrosBusca } from '../../helpers/ValidaAgente';
import MyTextField, { MaskType } from '../../components/inputs/inputBusca';
import Paginacao from '../../components/paginacao/paginacao';
import { dataValida, formatarData } from '../../helpers/utils'
import { StatusLegend } from '../../components/legend/StatusLegend';
import { useAgente } from '../hooks/agente';
import { usePedido } from '../hooks/pedido';
import ModalMensagem from '../../components/modal/Modal';

function Pedido() {
    const navigate = useNavigate();
    const userInfo: UserInfo = JSON.parse(localStorage.getItem('udbs')!);
    const REACT_APP_ADM_MOBILE = process.env.REACT_APP_ADM_MOBILE;
    const arrayColunas: string[] = ['nroDocumentoPedido', 'nroPedido', 'nome', 'cnpjCpf', /* 'total', */ 'dataLancamento'];
    const [pedidos, setPedidos] = useState<PedidoDto[]>([]);
    const [isLoading, setIsLoading] = useState(false);
    const [page, setPage] = useState(1);
    const [pageSize] = useState(15);
    const [totalRegistros, setTotalRegistros] = useState(0);
    const [searchTerm, setSearchTerm] = useState('');
    const [filteredPedidos, setFilteredPedidos] = useState<PedidoDto[]>([]);
    const [colunaFilter, setColunaFilter] = useState<string | null>(null);
    const [colunas, setColunas] = useState<string[]>(arrayColunas);
    const [erro, setErro] = useState('');
    const erroNaBusca = useRef(false);
    const jaBuscouRef = useRef(false);
    const [buscouPedidos, setBuscouPedidos] = useState(false);
    const [mostrarLista, setMostrarLista] = React.useState(true);
    const { modoBloqueado, setModoBloqueado, dadosInvalidos, buscouTabPreco, buscouFormaCob, buscouPlanoPgto } = usePedido();
    const [openModal, setOpenModal] = useState(false);

    const dataAtual = new Date();
    const umaSemanaAtras = new Date();
    umaSemanaAtras.setDate(dataAtual.getDate() - 7);

    const pedidosService = new PedidosServices(() => {
        navigate('/mvp', {
            state: {
                propsPage: 'login'
            }
        });
    }); 

    useEffect(() => {
        if (userInfo.email === REACT_APP_ADM_MOBILE) {
            return
        }
    }, [userInfo]);

    useEffect(() => {
        if (erro !== "") {
            mostraMensagemErro(erro);
        }
    }, [erro]);

    /*   //Verifica se a empresa tem os dados comerciais cadastrados
      function confereDadosEmpresa(): any[] {
          const dados: any[] = [];
  
          if (formaCob.length === 0) {
              dados.push({ titulo: 'Empresa', mensagem: ['Empresa não possui nenhuma forma de cobrança cadastrada.'] });
          }
          if (planoPagamento.length === 0) {
              dados.push({ titulo: 'Empresa', mensagem: ['Empresa não possui nenhum plano de pagamento cadastrado.'] });
          }
          if (tabPreco.length === 0) {
              dados.push({ titulo: 'Empresa', mensagem: ['Empresa não possui nenhuma tabela de preço cadastrada.'] });
          }
  
          setDadosInvalidos(dados);
          return dados;
      }*/

    useEffect(() => {
        const buscasDadosEmpresaConcluidas = buscouTabPreco && buscouFormaCob && buscouPlanoPgto;

        if (buscasDadosEmpresaConcluidas && modoBloqueado && dadosInvalidos.length > 0) {
            setOpenModal(true);
        }
    }, [buscouFormaCob, buscouPlanoPgto, buscouTabPreco, dadosInvalidos.length, modoBloqueado]);


    // Busca inicial ao montar a página
    useEffect(() => {
        if (searchTerm.trim() === '') {
            if (!jaBuscouRef.current) {
                jaBuscouRef.current = true;
                buscaPedidos();
            }
        } else if (colunaFilter === 'dataLancamento') {
            const datas = searchTerm.split('|');
            if (dataValida(datas[0]) && dataValida(datas[1])) {
                buscaPedidosFiltro();
            }
        }
    }, [searchTerm]);

    // Busca ao navegar entre páginas (pula o primeiro render)
    useEffect(() => {
        if (jaBuscouRef.current) {
            buscaPedidos();
        }
    }, [page]);


    const handleBuscarComFiltro = () => {
        if (colunaFilter === 'dataLancamento') {
            const datas = searchTerm.split('|');
            if (!dataValida(datas[0]) || !dataValida(datas[1])) {
                mostraMensagemErro("Data inválida");
                return;
            }
        }
        buscaPedidosFiltro();
        setPage(1);
    };

    async function buscaPedidos() {
        setIsLoading(true);

        try {
            const response = await pedidosService.get(`/v1/pedido?idEmpresa=${userInfo.idEmpresa}&&agenteRepresentante=${userInfo.idAgente}`);
            //const response = {codigo:400, mensagem:"Erro", status: {pedidos:[], total:0}}
            if (response.codigo !== 200) {
                if (response.mensagem.includes("Failed to fetch")) {
                    setErro("Não foi possível conectar ao servidor. Verifique sua conexão.");
                } else {
                    setErro(response.mensagem);
                    setPedidos([]);
                    setFilteredPedidos([]);
                    setTotalRegistros(0);
                }
                erroNaBusca.current = true;
                return

            } else if (response.status.total === 0 || response.status.pedidos === null) {
                setPedidos([]);
                setFilteredPedidos([]);
                setTotalRegistros(0);
                setErro('Não há registros');
                erroNaBusca.current = true;
                setBuscouPedidos(true);
            } else {
                const pedidosFormatados: PedidoDto[] = await processarPedidos(response.status.pedidos);
                setErro('');
                setPedidos(pedidosFormatados);
                setFilteredPedidos(pedidosFormatados);
                setTotalRegistros(response.status.total || 0);
                erroNaBusca.current = false;
            }
            setBuscouPedidos(true)

        } catch (error: any) {
            console.error('Erro ao buscar pedidos:', error);
            setErro(error.message || 'Erro inesperado');
            erroNaBusca.current = true;
            setPedidos([]);
            setFilteredPedidos([]);
            setTotalRegistros(0);
        } finally {
            setIsLoading(false);
        }
    }

    async function processarPedidos(pedidos: PedidoDto[]): Promise<PedidoDto[]> {
        if (!pedidos || !Array.isArray(pedidos)) {
            return [];
        }

        return pedidos.map(pedido => {

            const valorStatus = pedido.agenteAtivo
                ? (pedido.agenteAtivo ? "S" : "N")
                : "N";

            /* console.log("Pedido:", pedido.idPedido,
                "Agente:", pedido.idAgente,
                "Status encontrado:", valorStatus); */

            return {
                ...pedido,
                dataLancamentoFormated: pedido.dataLancamento ? formatarData(pedido.dataLancamento.toString()) : '',
                statusAgente: valorStatus
            };
        });
    }

    async function buscaPedidosFiltro() {
        const pFiltro = formataFiltrosBusca(colunaFilter!, searchTerm);

        setIsLoading(true);
        try {
            const response = await pedidosService.get(
                `/v1/pedido?idEmpresa=${userInfo.idEmpresa}&&agenteRepresentante=${userInfo.idAgente}&${colunaFilter}=${pFiltro}`
            );

            if (response.codigo !== 200) {
                if (response.mensagem.includes("Failed to fetch")) {
                    return mostraMensagemErro("Não foi possível conectar ao servidor. Verifique sua conexão.");
                }
                mostraMensagemErro(response.mensagem);
                setPedidos([]);
                setFilteredPedidos([]);
                setTotalRegistros(0);
                return;
            } else if (response.status.total === 0 || response.status.pedidos === null) {
                setPedidos([]);
                setFilteredPedidos([]);
                setTotalRegistros(0);
                setBuscouPedidos(true)
                setErro("Não há registros.")
                erroNaBusca.current = true;
            } else {
                const pedidosFormatados: PedidoDto[] = await processarPedidos(response.status.pedidos);
                //setPedidos(pedidosFormatados);
                setFilteredPedidos(pedidosFormatados);
                setTotalRegistros(response.status.total || 0);
            }
            erroNaBusca.current = false

        } catch (error) {
            //setPedidos([]);
            setFilteredPedidos([]);
            setTotalRegistros(0);
        } finally {
            setIsLoading(false);
        }
    }

    const handlePageChange = (event: React.ChangeEvent<unknown>, value: number) => {
        setPage(value);
    };

    const novoPedido = () => {
        navigate("/mvp", {
            state: {
                propsPage: "novoPedido"
            }
        })
    }

    const dadosPaginados = filteredPedidos.slice(
        (page - 1) * pageSize,
        page * pageSize
    );

    function Voltar() {
        setMostrarLista(false);
    }

    async function editarPedido(pedido: PedidoDto) {
        navigate("/mvp", {
            state: {
                pedido,
                propsPage: "editarPedido"
            }
        })
    }

    async function handleEditarPedido(pedido: PedidoDto) {
        await editarPedido(pedido);
    }

    async function visualizarPedido(pedido: PedidoDto) {
        navigate("/mvp", {
            state: {
                pedido,
                propsPage: "visualizarPedido"
            }
        })
    }

    async function handleVisualizarPedido(pedido: PedidoDto) {
        await visualizarPedido(pedido);
    }

    return (
        <div style={{ pointerEvents: modoBloqueado ? "none" : "auto", opacity: modoBloqueado ? 0.5 : 1 }}>

            <div className="Home">
                {isLoading && <Loading />}
                <Paper elevation={0} className='pedidos-paper-header'>
                    <Box className='pedidos-header-top'>
                        <Box className='pedidos-title-wrap'>
                            <Box className='pedidos-title-icon'>
                                <ReceiptLongIcon />
                            </Box>
                            <Box>
                                <Box className='pedidos-title-line'>
                                    <Typography variant='h6' className='pedidos-title'>
                                        Pedidos Cadastrados
                                    </Typography>
                                </Box>
                                <Typography className='pedidos-subtitle'>
                                    Acompanhe os pedidos cadastrados e seus detalhes.
                                </Typography>
                            </Box>
                        </Box>
                        <Divider className='pedidos-divider' />
                    </Box>

                    <Button
                        className='pedidos-btn-novo'
                        variant='contained'
                        onClick={novoPedido}
                    >
                        Novo pedido
                    </Button>

                    <Box className='pedidos-filtros-row'>
                        <FormControl size='small' className='pedidos-form-control'>
                            <InputLabel shrink>Filtrar por</InputLabel>
                            <Select
                                value={colunaFilter}
                                onChange={(e: any) => {
                                    setColunaFilter(e.target.value);
                                    setSearchTerm("");
                                }}
                                label='Filtrar por'
                                displayEmpty
                                sx={{
                                    '& .MuiSelect-select': {
                                        fontSize: '13px',
                                    },
                                }}
                            >
                                {colunas.map((item) => (
                                    <MenuItem key={item} value={item} className='pedidos-menu-item'>
                                        {item === 'nroPedido' ? 'Nro Pedido' :
                                            item === 'nroDocumentoPedido' ? 'Nro Pedido Odin' :
                                                item === 'cnpjCpf' ? 'CNPJ/CPF' :
                                                    item === 'dataLancamento' ? 'Data de Lançamento' :
                                                        item.charAt(0).toUpperCase() + item.slice(1)}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>

                        <Box className={`pedidos-search-box ${colunaFilter === 'dataLancamento' ? 'pedidos-search-box-data' : ''}`}>
                            <MyTextField
                                tipo={colunaFilter as MaskType}
                                value={searchTerm}
                                onValueChange={setSearchTerm}
                                onClear={() => {
                                    setSearchTerm("");
                                    setFilteredPedidos(pedidos);
                                }}
                                onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                        handleBuscarComFiltro();
                                    }
                                }}
                            />
                        </Box>

                        {colunaFilter !== 'dataLancamento' && (
                            <IconButton
                                aria-label='Pesquisar'
                                className='pedidos-btn-buscar'
                                onClick={handleBuscarComFiltro}
                                disabled={searchTerm === "" && colunaFilter !== "dataLancamento"}
                            >
                                {searchTerm !== "" || colunaFilter === "dataLancamento" ? <SearchIcon /> : <SearchOffIcon />}
                            </IconButton>
                        )}

                        <button
                            className='pedidos-limpar'
                            onClick={() => {
                                setSearchTerm("");
                                setColunaFilter(null);
                                setFilteredPedidos(pedidos);
                                buscaPedidos();
                            }}
                        >
                            Limpar filtros
                        </button>
                    </Box>
                </Paper>
                {/*<StatusLegend />*/}
                {/*<Box className='ContainerTop'>Teste</Box>*/}

                <div className="ContainerListaPedidos">
                    <CustomOrderTableComponent
                        data={dadosPaginados}
                        deleteData={undefined}
                        isHome={false}
                        handleEditarPedido={handleEditarPedido}
                        handleVisualizarPedido={handleVisualizarPedido}
                    />

                    <div className="PaginationContainer">
                        <Paginacao
                            totalRegistros={totalRegistros}
                            paginaAtual={page}
                            porPagina={pageSize}
                            aoMudarPagina={handlePageChange}
                        />
                    </div>
                </div>
                <ModalMensagem
                    mensagem='Dados inválidos'
                    open={openModal}
                    onClose={() => setOpenModal(false)}
                    dados={dadosInvalidos}
                />

                <ToastContainer />
            </div>
        </div>
    );
}

export default Pedido;
